import * as React from "react";
import "./checkbox.css";
import "../../style/fonts.css";
import checked from "../../icons/checkbox_checked.svg";
import unchecked from "../../icons/checkbox_unchecked.svg";
import infoIcon from "../../icons/info_filled.svg";

export interface Props {
  text: string;
  checked: boolean;
  onClick: () => void;
  onClickInfo: () => void;
}

class Checkbox extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  show() {
    if (this.props.checked) {
      return (
        <div className="CHECKED">
          <img src={checked} />
        </div>
      );
    } else {
      return (
        <div className="UNCHECKED">
          <img src={unchecked} />
        </div>
      );
    }
  }

  render() {
    return (
      <div className="CHECKBOX_CONT">
        <div className="CHECKBOX_CONT_INNER" onClick={this.props.onClick}>
          <div className="CHECKBOX">{this.show()}</div>
          <div className="CHECKBOX_TEXT">
            <div className="SMALL_TEXT1">{this.props.text}</div>
          </div>
        </div>
        <div onClick={this.props.onClickInfo}>
          <img src={infoIcon} className={"CHECKBOX_INFO_ICON"} />
        </div>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/checkbox/checkbox.tsx